import React, { useEffect, useRef } from "react";
import classNames from "classnames";

var styles = {
  textAreaContainer: {
    position: "relative",
    display: "flex",
    flex: "1",
    width: "100%",
    minWidth: "10px",
    flexDirection: "column",
    marginBottom: "10px",
  },
  errors: {
    paddingTop: "4px",
    bottom: "-22px",
    position: "absolute",
    fontSize: "11px",
    fontWeight: "400",
    userSelect: "none",
    color: "#FF0000",
  },
  errors2: {
    right: "90px",
    bottom: "-42px",
    position: "absolute",
    fontSize: "11px",
    fontWeight: "400",
    userSelect: "none",
    color: "#FF0000",
  },
};

export default ({
  formik,
  fieldName,
  fieldName2,
  background,
  parentStyle,
  textColor,
  scrollActivate = false,
  errorClass,
  secondErrorClass,
  placeholder = "Say something",
  rows = 3,
  countClass = false,
  textAreaClass = false,
  disabled = false,
  hasError = false,
  boxShadow = "",
  errorMessage = "",
  allowEnterKey = true,
  ...props
}) => {
  const classes = styles;
  const textAreaEl = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      (async () => {
        await formik.submitForm();
      })();
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  useEffect(() => {
    if (!scrollActivate) return;

    var textarea = textAreaEl.current;
    textarea.addEventListener("input", function () {
      this.style.height = "auto";
      this.style.height = this.scrollHeight + "px";
    });
  }, [scrollActivate]);

  return (
    <div
      style={{ ...classes.textAreaContainer, ...parentStyle }}
      className="size"
    >
      <textarea
        ref={textAreaEl}
        onKeyDown={!allowEnterKey ? handleKeyDown : () => {}}
        className={classNames({
          [textAreaClass]: textAreaClass && true,
          whitePlaceholder: textColor === "white",
          blackPlaceholder: textColor === "black",
          errorField: (formik?.errors[fieldName] && true) || hasError,
        })}
        disabled={disabled}
        type="text"
        placeholder={placeholder}
        {...formik.getFieldProps(fieldName)}
        rows={rows}
        style={{
          background: background,
          boxShadow: boxShadow,
          color: textColor,
        }}
        {...props}
      />
      <span
        style={classes.count}
        className={classNames({
          countTextArea: true,
          "fs-12 color-light text-end py-1": true,
          [countClass]: countClass && true,
        })}
      >
        {formik?.values[fieldName]?.length !== 0 &&
          formik?.values[fieldName]?.length}
      </span>
      <div>
        {errorMessage && (
          <>
            <span style={classes.errors} className={errorClass}>
              {errorMessage}
            </span>
          </>
        )}

        {formik?.errors[fieldName] && (
          <>
            <span style={classes.errors} className={errorClass}>
              {formik?.errors[fieldName]}
            </span>
          </>
        )}

        {formik?.errors[fieldName2] && (
          <>
            <span style={classes.errors2} className={secondErrorClass}>
              {formik?.errors[fieldName2]}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
